import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';

@Injectable()
export class AdjuntoService extends TokenCommonService  {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  all (params?: any) {
    const result = this.tokenGet(`${ environment.API_URL }attachments/todos`, params);
    return result;
  }

  edit(id: number, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }attachments/${id}`, data);
  }

  crear(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }attachments`, data);
  }

  eliminar(id: number) {
    return this.tokenDelete(`${ environment.API_URL }attachments/${id}`);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/adjunto/adjunto.service.ts